$(document).ready(function () {

	$('.menu_footer-arrow').on('click', function() {
		var collapse = $(this).closest('.menu_footer--width-a').find('.menu_footer--child-flex');

		if (collapse.hasClass('show')) {
			collapse.removeClass('show');
		}else {
			collapse.addClass('show');
		}
	})

	$('.rozwin').on('click', function() {
		// var collapse = $(this).closest('.rzowin_wrap').find('.ulice');
		var id = $(this).data('id');
		var collapse = $('.collapse-id_'+id);

		if (collapse.hasClass('show')) {
			collapse.removeClass('show');
			$(this).find('.rozwin_svg').addClass('rotate_svg');
		}else {
			collapse.addClass('show');
			$(this).find('.rozwin_svg').removeClass('rotate_svg');
		}
	})

	$('.wylaczenia--table-header').on('click', function() {
		var collapse = $(this).closest('.wylaczenia--table').find('.wylaczenia--table-body');

		if (collapse.hasClass('show')) {
			collapse.removeClass('show');
			$(this).find('.wylaczenia--table-header--svg').addClass('rotate_svg');
		}else {
			collapse.addClass('show');
			$(this).find('.wylaczenia--table-header--svg').removeClass('rotate_svg');
		}
	})
});